import { createSlice } from "@reduxjs/toolkit";
import { logOut } from "./auth";

const initialState = [];

export const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setApplications: (state, { payload }) => {
      return payload;
    },
    updateApplication: (state, { payload }) => {
      return state.map((application) =>
        application.id === payload.id ? payload : application
      );
    },
    deleteApplication: (state, { payload }) => {
      return state.filter((application) => application.id !== payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logOut, () => {
      return [];
    });
  },
});

export const { setApplications, updateApplication, deleteApplication } =
  applicationSlice.actions;

export default applicationSlice.reducer;
